import { backendGet, backendPost, backendPut, backendDelete } from '../lib/backendClient';

export async function getProductsByStoreId(storeId) {
  return await backendGet(`/api/products/${storeId}?include_unavailable=true`);
}

export async function createProduct(productData) {
  return await backendPost('/api/products/cadastrar', productData);
}

export async function updateProduct(productId, productData) {
  return await backendPut(`/api/products/${productId}`, productData);
}

export async function deleteProduct(productId) {
  return await backendDelete(`/api/products/${productId}`);
}
